export type WhatIDoItem = {
  number: string;
  title: string;
  description: string;
  /** Product id for wizard prefill */
  productId: string;
  href: string;
  image: string;
};

export type ApproachStep = {
  number: string;
  title: string;
  description: string;
};

export type SkillColumn = {
  title: string;
  items: string[];
};

export type JourneyRow = {
  period: string;
  role: string;
  description: string;
};

export const APPROACH_STEPS: ApproachStep[] = [
  {
    number: "01",
    title: "Listen",
    description:
      "Short, direct conversations to understand the actual problem — not just the brief.",
  },
  {
    number: "02",
    title: "Shape",
    description:
      "I propose a small, specific scope we can ship — design only, code only, or both.",
  },
  {
    number: "03",
    title: "Make",
    description: "Weekly delivery in public. You see real work, not status decks.",
  },
  {
    number: "04",
    title: "Hand off",
    description:
      "Clear documentation, working code, calm handover. Or stick around for the next round.",
  },
];

export const WHAT_I_DO_ITEMS: WhatIDoItem[] = [
  {
    number: "01",
    title: "Website",
    description: "Marketing sites that convert.",
    productId: "website",
    href: "/services/products/website",
    image: "/images/projects/web1.webp",
  },
  {
    number: "02",
    title: "E-shop",
    description: "Stores with clear checkout.",
    productId: "eshop",
    href: "/services/products/eshop",
    image: "/images/projects/2014/_Bbq.sk/bbq/2.webp",
  },
  {
    number: "03",
    title: "Portfolio",
    description: "Sites that show your work.",
    productId: "portfolio",
    href: "/services/products/portfolio",
    image: "/images/projects/product1.webp",
  },
  {
    number: "04",
    title: "Web App",
    description: "SaaS and dashboards.",
    productId: "web-app",
    href: "/services/products/web-app",
    image: "/images/projects/product1.webp",
  },
  {
    number: "05",
    title: "Mobile App",
    description: "Native iOS & Android UX.",
    productId: "mobile-app",
    href: "/services/products/mobile-app",
    image: "/images/projects/mobile1.webp",
  },
  {
    number: "06",
    title: "Brand Identity",
    description: "Logo and visual systems.",
    productId: "brand-identity",
    href: "/services/products/brand-identity",
    image: "/images/projects/identity1.webp",
  },
  {
    number: "07",
    title: "Games & Interactive",
    description: "Playful product UI.",
    productId: "games-interactive",
    href: "/services/products/games-interactive",
    image: "/images/projects/2024/intobridge/intobridge-cover.png",
  },
  {
    number: "08",
    title: "Micro Page",
    description: "One simple page, live fast.",
    productId: "micro-page",
    href: "/services/products/micro-page",
    image: "/images/projects/2026/wildpoppy.sk/cover.png",
  },
];

export const SKILL_COLUMNS: SkillColumn[] = [
  {
    title: "Design",
    items: [
      "UX research",
      "Information architecture",
      "Wireframing",
      "UI design",
      "Prototyping",
      "Design systems",
    ],
  },
  {
    title: "Development",
    items: [
      "HTML / CSS",
      "JavaScript / TypeScript",
      "React",
      "WordPress",
      "Jamstack",
      "Performance & SEO",
    ],
  },
  {
    title: "Product",
    items: [
      "Product strategy",
      "User testing",
      "Analytics",
      "Agile delivery",
      "Stakeholder workshops",
      "Design sprints",
    ],
  },
];

export const JOURNEY_ROWS: JourneyRow[] = [
  {
    period: "2024 — now",
    role: "Independent",
    description: "Product design and front-end for founders and teams.",
  },
  {
    period: "2018 — 2024",
    role: "Yotta / Alloy",
    description: "Lead product design for connected asset management platform.",
  },
  {
    period: "2013 — 2018",
    role: "Button Systems",
    description: "UI/UX for VoIP web and mobile products in the B2B space.",
  },
  {
    period: "2008 — 2013",
    role: "Freelance & agencies",
    description: "Web design and development for clients across finance and services.",
  },
];
